import { BreakpointObserver } from '@angular/cdk/layout';
import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { FreelancerBreakpoints } from '@freelancer/ui/breakpoints';
import * as Rx from 'rxjs';
import { ViewHeaderTemplate } from './view-header-template.service';

export enum ViewHeaderType {
  /** Inject the header into the nav on mobile */
  MOBILE_ONLY = 'mobile_only',
  /** Inject into the nav on mobile, but leave in the template on tablet and up */
  SHOW_ALL = 'show_all',
}

@Directive({ selector: '[flViewHeaderTemplate]' })
export class ViewHeaderTemplateDirective implements OnInit, OnDestroy {
  @Input() flViewHeaderTemplate = ViewHeaderType.MOBILE_ONLY;

  private mobileRegistrationSubscription?: Rx.Subscription;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
    private viewHeaderTemplate: ViewHeaderTemplate,
    private breakpointObserver: BreakpointObserver,
  ) {}

  ngOnInit() {
    // use breakpoint here to only register the global header on mobile views
    // otherwise, the template injection in the navigation can mess with
    // the local template embedded view and result in no content sometimes
    this.mobileRegistrationSubscription = this.breakpointObserver
      .observe(FreelancerBreakpoints.TABLET)
      .subscribe(tablet => {
        this.viewContainerRef.clear();
        this.viewHeaderTemplate.deregisterHeader(this.templateRef);
        if (
          tablet.matches &&
          this.flViewHeaderTemplate === ViewHeaderType.SHOW_ALL
        ) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
          this.viewHeaderTemplate.registerHeader(this.templateRef);
        }
      });
  }

  ngOnDestroy() {
    this.viewHeaderTemplate.deregisterHeader(this.templateRef);
    if (this.mobileRegistrationSubscription) {
      this.mobileRegistrationSubscription.unsubscribe();
    }
  }
}
